var exports = {
  "Kk": "xcc377c0b--865238--icon",
  "NX": "xcc377c0b--865238--icon--opened",
  "x6": "xcc377c0b--865238--button",
};

module.exports = exports;
